export default "__VITE_PUBLIC_ASSET__499ac9be__"